import { createSlice } from '@reduxjs/toolkit';

// Transient UI state for the "Report a problem" modal. `source` records the
// entry point (user-menu | help-menu | error-screen) for analytics; when
// opened from an error surface, `errorContext` carries the error details so
// they ride along with the report.
const initialState = {
    open: false,
    source: null,
    errorContext: null,
};

const reportSlice = createSlice({
    name: 'report',
    initialState,
    reducers: {
        openReportModal(state, action) {
            state.open = true;
            state.source = action.payload?.source || null;
            state.errorContext = action.payload?.errorContext || null;
        },
        closeReportModal(state) {
            state.open = false;
            state.source = null;
            state.errorContext = null;
        },
    },
});

export const { openReportModal, closeReportModal } = reportSlice.actions;

export default reportSlice.reducer;
